import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const StyledInfoPanel = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  padding: '$6 $6 $6 $6',
  overflow: 'hidden',
  width: '100%',

  '&:first-child': {
    paddingBottom: '0',
  },
});

export const StyledContent = styled(Box, {
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  whiteSpace: 'break-spaces',
  width: '80%',
});

export const StyledDescription = styled(Box, {
  color: '$darkBlue400',
  fontSize: '$sm',
  fontWeight: '$regular',
  lineHeight: '$6',
  whiteSpace: 'nowrap',
});

export const StyledDivisor = styled(Box, {
  border: '1px solid $seafoam600',
  width: '90%',
  margin: '$4 0',
});

export const StyledRemaining = styled(Box, {
  color: '$darkBlue300',
  fontSize: '$4',
  overflow: 'hidden',
  textAlign: 'left',
});

export const StyledConversionRateGoal = styled(Box, {
  color: '$darkBlue300',
  fontSize: '$4',
  overflow: 'hidden',
  textAlign: 'left',
});
